import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AppConfigService, KetQuaTraCuu, PhanKhuChucNang } from 'lib';
import { Subscription } from 'rxjs';
import { SharedService } from '../../../shared/shared.service';
import { SideBarIndex } from '../side-bar/side-bar.model';
import { SideBarService } from '../side-bar/side-bar.service';
import { DlgTakePictureComponent } from './dlg-take-picture/dlg-take-picture.component';

@Component({
  selector: 'web-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss']
})
export class ResultComponent implements OnInit, OnDestroy {
  data: KetQuaTraCuu;
  subcribe: Subscription;
  loading: boolean;
  message: string;
  directionLink = '';
  note: SafeHtml;
  constructor(
    public service: SharedService,
    private sidebarService: SideBarService,
    public dialog: MatDialog,
    private configService: AppConfigService,
    private sanitized: DomSanitizer
  ) { }

  ngOnInit() {
    this.configService.getApp().subscribe(value => {
      if(value.map.notes && value.map.notes.ketQua){
        this.note = this.sanitized.bypassSecurityTrustHtml(value.map.notes.ketQua);
      }
    });
    this.subcribe = this.service.ketQuaTraCuu$.subscribe(val => {
      this.data = val.data;
      this.loading = val.loading;
      this.message = val.message;
      if (this.data) {
        this.loadDirectionLink();
      }
    });
  }

  ngOnDestroy(): void {
    this.subcribe.unsubscribe();
  }

  handleClose() {
    this.service.close();
  }

  handleGoTo() {
    if (this.data.geometry) {
      this.service.view.goTo(this.data.geometry);
    } 
  }

  handleNewSearch() {
    this.sidebarService.handleChangeSideBarTab(SideBarIndex.Search, false);
    this.service.close();
  }

  handleTakePicture() {
    this.service.view.takeScreenshot()
      .then(result => {
        this.dialog.open(DlgTakePictureComponent, {
          maxWidth: '700px',
          width: '90wh',
          data: { src: result.dataUrl }
        });
      });
  }

  getBackgroundColor(phanKhuChucNang:PhanKhuChucNang){
    return 'rgba(' + phanKhuChucNang.color + ')'
  }

  async loadDirectionLink() {
    let url = 'https://www.google.com/maps'
    if (this.data.geometry) {
      const centroid = this.data.geometry.centroid;
      if (centroid) {
        const { latitude, longitude } = centroid;
        // lấy tọa độ center để gán vào link tìm kiếm của google
        url = `https://www.google.com/maps/dir//${latitude},${longitude}`;
      }
      this.directionLink = url;
    } 
   
  }
}
